import React from "react";
import {  useNavigate  } from "react-router-dom";
import Language from "../images/language.svg";
import flag_kor_small from "../images/flag_kor_small.png";
import flag_eng_small from "../images/flag_eng_small.png";
import flag_thai_small from "../images/flag_thai_small.png";
import flag_viet_small from "../images/flag_viet_small.png";

import i18n from "i18next";
import { useTranslation } from 'react-i18next';

import { LanguageTheme } from "../services/common";

export default function LanguageMain({changeTheme, mode}){
    const { t } = useTranslation();
    const navigate = useNavigate();  

    const lang = localStorage.getItem("language") || "ko";
    
    const changeLanguage = (e) =>{
        i18n.changeLanguage(e.target.value);
        localStorage.setItem("language", e.target.value);
        changeTheme(LanguageTheme());        
    };


    const fn_closeLang = (e) =>{
        let expire = new Date();
        expire.setTime(expire.getTime() + (1 * 24 * 60 * 60 * 1000));
        localStorage.setItem("languageNoShow", expire.getTime());
        window.location.reload();
    }


    const fn_setLanguage  = (e) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang);
        changeTheme(LanguageTheme());        


        if(mode) {
            window.location.reload();
        }else{
            navigate(-1);
        }            
    }
    
    return (
        <div className="backGround bgBlue">
            <div className="languageWr">
                <div className="dfColG40">
                    <div className="txtWr">
                        <img src={Language} alt="언어" />
                        <h3 className="fs18 cNavy fw800 mt10">{t(`Message.language_settings_title`)}</h3>                        
                        <p className="ment">{t(`Message.language_settings_explanation1`)} {t(`Message.language_settings_explanation2`)}</p>        
                                        
                    </div>
                    <ul className="dfColG12">
                        <li>
                            <input type="radio" name="language" id="kor" checked={lang==="ko"} onChange={changeLanguage} value="ko"></input>
                            <label htmlFor="kor">
                                <img src={flag_kor_small} alt="한국" />
                                <span className="txt">한국어</span>
                            </label>
                        </li>
                        <li>
                            <input type="radio" name="language" id="eng"  checked={lang==="en"} onChange={changeLanguage} value="en"></input>
                            <label htmlFor="eng">
                                <img src={flag_eng_small} alt="미국" />
                                <span className="txt">English</span>
                            </label>
                        </li>
                        <li>
                            <input type="radio" name="language" id="viet"  checked={lang==="vn"} onChange={changeLanguage} value="vn"></input>
                            <label htmlFor="viet">
                                <img src={flag_viet_small} alt="베트남" />
                                <span className="txt">Tiếng Việt</span>
                            </label>
                        </li>
                        <li>
                            <input type="radio" name="language" id="thai"  checked={lang==="th"} onChange={changeLanguage} value="th"></input>
                            <label htmlFor="thai">
                                <img src={flag_thai_small} alt="태국" />
                                <span className="txt">ไทย</span>
                            </label>
                        </li>
                    </ul>
                </div>
                <div className="langBtnWr">
                    <button type="submit" className="btn48 orgB cFFF" onClick={fn_setLanguage}>{t(`Message.language_settings_startbutton`)}</button>               
                    {mode ? (
                    <div className="chkWr">
                        <input type="checkbox" id="a" onClick={fn_closeLang} />
                        <label htmlFor="a">오늘 하루 보지 않기</label>
                    </div>
                    ):null}
                </div>
            </div>
        </div>
    )
};